import { ARBITRUM_CONTRACT, BASE_CONTRACT, BNB_CONTRACT, POLYGON_CONTRACT } from "@/types/address";
import { DEFAULT_ADDRESS } from "@/types/enum";

// NAME
const STORE_NAME = "state";

// NETWORK
const NETWORK_CONFIG = {
  HOST: import.meta.env.VITE_APP_URL,
  API_BASE_URL: import.meta.env.VITE_APP_URL,
  NEW_API_BASE_URL: import.meta.env.VITE_NEW_APP_URL,
  PRIVY_APP_ID: import.meta.env.VITE_PRIVY_APP_ID,
  BASE_URL: import.meta.env.VITE_WEB_URL,
  TIMEOUT: 30000,
  RETRY: false,
  DISPLAY_ERROR: import.meta.env.VITE_DISPLAY_ERROR === "true",
  USE_TOKEN: true,
  WITH_METADATA: false,
  MIN_DEPOSIT: 200,
  HIGHLIGHT_PROJECT_ID: import.meta.env.HIGHLIGHT_PROJECT_ID,
};

const DOMAIN = {
  DEV: import.meta.env.VITE_DEV_DOMAIN,
  PROD: import.meta.env.VITE_PROD_DOMAIN,
  LOCAL: "localhost:3000",
};

// PATHNAME
const PATHNAME = {
  HOME: "/",
  VAULT: "/dashboard",
  LOGIN: "/login",
  USER_PROFILE: "/user-profile",
  NOT_FOUND: "/not-found",
  LEADERBOARD: "/leaderboard",
  EDIT_PROFILE: "/edit-profile",
  VERIFY: "/verify",
  MAINTAIN: "/maintain",
};

// LANGUAGE
const LANGUAGE = {
  DEFAULT: "en",
};

const BASE = {
  ROUTER_LOCAL: BASE_CONTRACT.ROUTER_LOCAL,
  CROSS_CHAIN: BASE_CONTRACT.CROSS_CHAIN_ROUTER,
  FUND_VAULT: BASE_CONTRACT.FUND_VAULT_ADDRESS,
  ADDRESS: BASE_CONTRACT.CONTROLLER_ADDRESS,
  REFERRAL: BASE_CONTRACT.REFERRAL_ADDRESS,
  STARGATE: BASE_CONTRACT.STARGATE_CROSSCHAIN,
  USDC: BASE_CONTRACT.USDC_ADDRESS,
  USDT: BASE_CONTRACT.USDT_ADDRESS,
  LP_USDC: BASE_CONTRACT.LP_USDC,
  ALLBRIDGE: BASE_CONTRACT.ALLBRIDGE,
}

const ARBITRUM = {
  ROUTER_LOCAL: ARBITRUM_CONTRACT.ROUTER_LOCAL,
  CROSS_CHAIN: ARBITRUM_CONTRACT.CROSS_CHAIN_ROUTER,
  FUND_VAULT: ARBITRUM_CONTRACT.FUND_VAULT_ADDRESS,
  ADDRESS: ARBITRUM_CONTRACT.CONTROLLER_ADDRESS,
  STARGATE: ARBITRUM_CONTRACT.STARGATE_CROSSCHAIN,
  USDC: ARBITRUM_CONTRACT.USDC_ADDRESS,
  USDT: ARBITRUM_CONTRACT.USDT_ADDRESS,
  LP_USDC: ARBITRUM_CONTRACT.LP_USDC,
  ALLBRIDGE: ARBITRUM_CONTRACT.ALLBRIDGE,
}

const POLYGON = {
  ROUTER_LOCAL: POLYGON_CONTRACT.ROUTER_LOCAL,
  CROSS_CHAIN: POLYGON_CONTRACT.CROSS_CHAIN_ROUTER,
  FUND_VAULT: POLYGON_CONTRACT.FUND_VAULT_ADDRESS,
  ADDRESS: POLYGON_CONTRACT.CONTROLLER_ADDRESS,
  USDC: POLYGON_CONTRACT.USDC_E_ADDRESS,
  USDT: POLYGON_CONTRACT.USDT_ADDRESS,
  LP_USDC: POLYGON_CONTRACT.LP_USDC,
  COMPOUND: POLYGON_CONTRACT.COMPOUND,
}

const BNB = {
  ROUTER_LOCAL: BNB_CONTRACT.ROUTER_LOCAL,
  CROSS_CHAIN: BNB_CONTRACT.CROSS_CHAIN_ROUTER,
  FUND_VAULT: BNB_CONTRACT.FUND_VAULT_ADDRESS,
  ADDRESS: BNB_CONTRACT.CONTROLLER_ADDRESS,
  STARGATE: BNB_CONTRACT.STARGATE_CROSSCHAIN,
  USDC: BNB_CONTRACT.USDC_ADDRESS,
  USDT: BNB_CONTRACT.USDT_ADDRESS,
  LP_USDC: BNB_CONTRACT.LP_USDC,
  ALLBRIDGE: BNB_CONTRACT.ALLBRIDGE,
}

const DEFAULT_CASE = {
  ROUTER_LOCAL: DEFAULT_ADDRESS.DEFAULT,
  CROSS_CHAIN: DEFAULT_ADDRESS.DEFAULT,
  FUND_VAULT: DEFAULT_ADDRESS.DEFAULT,
  ADDRESS: DEFAULT_ADDRESS.DEFAULT,
  REFERRAL: DEFAULT_ADDRESS.DEFAULT,
  STARGATE: DEFAULT_ADDRESS.DEFAULT,
  USDC: DEFAULT_ADDRESS.DEFAULT,
  USDT: DEFAULT_ADDRESS.DEFAULT,
  LP_USDC: DEFAULT_ADDRESS.DEFAULT,
  ALLBRIDGE: DEFAULT_ADDRESS.DEFAULT,
  BALANCER: DEFAULT_ADDRESS.DEFAULT,
}

const RPC ={
  LINK_RPC: import.meta.env.VITE_RPC_KEY_BSC_LINK,
  TEST_LINK: import.meta.env.VITE_TEST_LINK,
  TEST_LINK_1: import.meta.env.VITE_TEST_LINK_1,
  TEST_LINK_2: import.meta.env.VITE_TEST_LINK_2,
  TEST_LINK_3: import.meta.env.VITE_TEST_LINK_3,
  TEST_LINK_4: import.meta.env.VITE_TEST_LINK_4,
  TEST_LINK_5: import.meta.env.VITE_TEST_LINK_5,
}

// SOCIAL
const SOCIAL = {
  FACEBOOK: import.meta.env.VITE_LINK_FACEBOOK,
  TELEGRAM: import.meta.env.VITE_LINK_TELEGRAM,
  TWITTER: import.meta.env.VITE_LINK_X,
  DISCORD: import.meta.env.VITE_LINK_DISCORD,
};

// SENTRY
const SENTRY = {
  DSN: import.meta.env.SENTRY_DSN,
};

export default {
  STORE_NAME,
  NETWORK_CONFIG,
  DOMAIN,
  PATHNAME,
  LANGUAGE,
  // CONTRACT,
  BASE,
  ARBITRUM,
  POLYGON,
  BNB,
  DEFAULT_CASE,
  RPC,
  SOCIAL,
  SENTRY,
};
